import { Button } from '@progress/kendo-react-buttons';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { logoutWI } from '../Store/Actions/Pages/AccessPage';

import { RedirectWithComponent } from '../Constants/Utils';
import { CookieAuthenModel } from '../Models/CommonModel/CookieAuthenModel';
import { storageModel } from '../Models/CommonModel/StorageModel';
import ErrorBoundary from '../Components/Common/ErrorBoundary';
import MessageBox, { ConfirmMessageResult, Pattern, Title } from '../Components/Common/MessageBox';
import { MessageBoxKey, MessageBoxModel } from '../Models/CommonModel/MessageBoxModel';

import Router from "../Resources/Router.json";
import Screen from "../Resources/Screen.json";
import UrlRedirect from "../Resources/UrlRedirect.json";
import '../Assets/Components/ErrorBoundary.css';

export function ErrorPage(props) {
    const cookieAuthenModel = new CookieAuthenModel();
    const [isShowError, setIsShowError] = useState(false);
    const [messageDialog, setMessageDialog] = useState(null);
    const [showMessageBox, setShowMessageBox] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (props?.location?.state?.enable) {
            // Always logout with isLogoutAll = false when called
            setIsShowError(true);

            let loginModel = cookieAuthenModel.GetWILoginModel();
            let segmentUrl = getSegmentUrl().toLowerCase();

            if (loginModel && segmentUrl === Router.Error) {
                let params = {
                    AccessKey: loginModel.AccessKey,
                    RequestKey: loginModel.RequestKey
                };

                const callBack = (res) => {
                    storageModel.Reset();
                };

                const logoutAction = logoutWI(params, false, callBack);
                dispatch(logoutAction);
            }
        }
        else {
            return RedirectWithComponent("/");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const formatDate = () => {
        let dt = new Date();
        return dt ? dt.getFullYear() + "/"
            + (dt.getMonth() < 9 ? '0' : '') + (dt.getMonth() + 1) + "/"
            + (dt.getUTCDate() < 10 ? '0' : '') + (dt.getUTCDate()) + " "
            + (dt.getHours() < 10 ? '0' : '') + dt.getHours() + ":"
            + (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes() + ":"
            + (dt.getSeconds() < 10 ? '0' : '') + dt.getSeconds() : "";
    }

    const getSegmentUrl = () => {
        let segments = window.location.pathname.split("/");
        return segments[segments.length - 1] ? segments[segments.length - 1] : segments[segments.length - 2];
    }

    // Event onClick when click button in MessageBox logut
    const onLogOut = (isLogoutAll) => {
        const callBack = (res) => {
            window.location.href = UrlRedirect.UrlFreee;
        };
        let loginModel = cookieAuthenModel.GetWILoginModel();
        if (isLogoutAll) {
            let params = {
                AccessKey: loginModel ? loginModel.AccessKey : null,
                RequestKey: loginModel ? loginModel.RequestKey : null
            };
            const logoutAction = logoutWI(params, true, callBack);
            dispatch(logoutAction);
        }
        else {
            RedirectWithComponent("/");
        }
    }

    const showDialogLogout = () => {
        let dialog = new MessageBoxModel({
            Sid: MessageBoxKey.Logout,
            Title: Title.DefaultTitle,
            Pattern: Pattern.OkCancel,
            Message: Screen.MessageBox.LogoutComfirm
        });
        setMessageDialog(dialog);
        setShowMessageBox(true);
    }

    const onSubmitMessageBox = (sid, value) => {
        switch (sid) {
            case MessageBoxKey.Logout:
                if (value === ConfirmMessageResult.Yes) {
                    onLogOut(true);
                }
                else if (value === ConfirmMessageResult.Cancel) {
                    onLogOut(false);
                }
                break;
            default:
                break;
        }

        // reset dialog & close
        setMessageDialog(null);
        setShowMessageBox(false);
    }

    // UI render
    return <React.Fragment>
        {isShowError && <ErrorBoundary>
            {messageDialog && showMessageBox &&
                <MessageBox sid={messageDialog.Sid}
                    title={messageDialog.Title}
                    pattern={messageDialog.Pattern}
                    message={messageDialog.Message}
                    submit={onSubmitMessageBox}>
                </MessageBox>}
            <div id="errorPage">
                <p className="textBold">{Screen.Error.ErrorLine1} </p>
                <p>{Screen.Error.ErrorLine2}</p>
                <p>{Screen.Error.ErrorLine3}<br /> {Screen.Error.ErrorLine4}</p>
                <p className="textRight">{Screen.Error.ErrorLine5}</p>
                <p className="textLeft">{Screen.Error.ErrorLine6}</p>

                <p className="textLeft box">
                    {Screen.Error.ErrorLine7}<input className="dateLabel" readOnly={true} type="text" value={formatDate()} />
                </p>
                <Button className="pnxBtnPrimary" style={{ float: 'right' }} onClick={showDialogLogout}>{Screen.Error.ButtonLogout}</Button>
            </div>
        </ErrorBoundary>
        }
    </React.Fragment>
}